import { Table } from '@tanstack/react-table';

interface Props<TData> {
    table: Table<TData>;
}

const DataGridFooterTotals = <TData extends object>({ table }: Props<TData>) => {
    const headers = table.getFlatHeaders();

    return table.getFooterGroups().map((group, groupIndex) => (
        <div key={`footerTotalsGroup-${groupIndex}`} className="dataGrid__footerTotals">
            <div className="flex relative my-auto" key={group.id}>
                {group.headers.map((header, headerIndex) => (
                    <div
                        style={{ width: headers[headerIndex].getSize() }}
                        className={`${header.column.columnDef?.meta?.className ? header.column.columnDef?.meta?.className : ''} font-bold box-border text-ellipsis p-[0.7rem]`}
                        key={`footerTotalsHeader-${groupIndex}-${headerIndex}`}
                    >
                        {typeof header.column.columnDef.footer === 'function' && <header.column.columnDef.footer {...header.getContext()} />}
                    </div>
                ))}
            </div>
        </div>
    ));
};

export default DataGridFooterTotals;
